import { render, staticRenderFns } from "./EntryBulkMessageTarget.vue?vue&type=template&id=447d0ea8"
import script from "./EntryBulkMessageTarget.vue?vue&type=script&lang=js"
export * from "./EntryBulkMessageTarget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports